import type { WiwState } from '@/store';

export const getWorkchatUsers = (state: WiwState) => {
  return state.workchat.users;
};
